import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ReportCard = ({ report, onGenerate, onPreview }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'ready':
        return 'text-success bg-success/10';
      case 'generating':
        return 'text-warning bg-warning/10';
      case 'draft':
        return 'text-muted-foreground bg-muted';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'ready':
        return 'CheckCircle';
      case 'generating':
        return 'Clock';
      case 'draft':
        return 'FileText';
      default:
        return 'FileText';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-elevated transition-all duration-200">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name={report.icon} size={24} className="text-primary" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground">{report.title}</h3>
            <p className="text-sm text-muted-foreground">{report.description}</p>
          </div>
        </div>
        <div className={`px-2 py-1 rounded-full text-xs font-medium flex items-center gap-1 ${getStatusColor(report.status)}`}>
          <Icon name={getStatusIcon(report.status)} size={12} />
          {report.status}
        </div>
      </div>

      <div className="space-y-3 mb-4">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Last Generated:</span>
          <span className="text-foreground">{report.lastGenerated}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Data Range:</span>
          <span className="text-foreground">{report.dateRange}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Pages:</span>
          <span className="text-foreground">{report.pages}</span>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <Button
          variant="default"
          size="sm"
          onClick={() => onGenerate(report)}
          disabled={report.status === 'generating'}
          loading={report.status === 'generating'}
          iconName="Download"
          iconPosition="left"
          className="flex-1"
        >
          Generate
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPreview(report)}
          iconName="Eye"
          iconPosition="left"
          className="flex-1"
        >
          Preview
        </Button>
      </div>
    </div>
  );
};

export default ReportCard;